export default "__VITE_ASSET__C8xVXv06__"